import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  BackgroundColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      pointerEvents: 'none',
    },
    corner: {
      position: 'absolute',
      top: Spacings.s2,
      right: Spacings.s2,
      zIndex: 1,
    },
    overlay: {
      position: 'absolute',
      inset: `calc(-1 * ${Spacings.s2})`,
    },
    inline: {
      marginLeft: Spacings.s6,
    },
    ring: {
      position: 'absolute',
      inset: 0,
      borderRadius: CornerRadius.circle,
      border: [2, 'solid', BackgroundColors.tint2],
      borderTopColor: PrimaryColors.base.default,
      animation: `$spin 0.8s ${Easings.linear} infinite`,
    },
    dot: {
      width: Spacings.s12,
      height: Spacings.s12,
      borderRadius: CornerRadius.circle,
      backgroundColor: PrimaryColors.base.default,
      border: [2, 'solid', BackgroundColors.base],
    },
  },
  { name: 'GenerationStatusBadge' }
);

export default useStyles;
